<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
import { mobileRem } from "@/common/rem";
import { AppDeviceEnquire } from "@/utils/mixin";
export default {
  mixins: [AppDeviceEnquire],
  components: {},
  data() {
    return {};
  },
  created() {
    const saved = localStorage.getItem('currentTheme');
    const theme = saved || (window.matchMedia('(prefers-color-scheme: dark)').matches ? 'night' : 'day');
    this.$store.dispatch("updateTheme", theme);
    window.document.documentElement.setAttribute("data-theme", theme);
    document.body.setAttribute('data-theme', theme === 'night' ? 'dark' : 'light');
    mobileRem()
  }
};
</script>

